import { render, staticRenderFns } from "./GroupDropDown.vue?vue&type=template&id=23b5782e&"
import script from "./GroupDropDown.vue?vue&type=script&lang=js&"
export * from "./GroupDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports